import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useFeatures } from 'flagged'
import { AppBar, Box, Toolbar } from '../../mui/Core/index'
import CompanyLogo from '../../../assets/images/company-logo.svg'
import LogoLines from '../../../assets/images/navbar-logo-lines.svg'
import { hasUserPermission } from '../../../utils/user-utils'
import { userPermissionConstants } from '../../../constants/user-permission-constants'
import Constants from '../../../constants/en.json'
import UserMenu from './components/UserMenu/user-menu'
import NavButtons from './components/NavButtons/nav-buttons'
import { useTheme } from '../../mui/Styles/index'

function GenericNav(props) {
  const theme = useTheme()
  const { selected } = props
  const features = useFeatures()
  const isUserServiceEnabled = features.isUserServiceEnabled
  const authenticatedUser = useSelector((state) => state.login.authenticatedUser)
  const hasUserManagementAccess = hasUserPermission({
    permissionCode: userPermissionConstants.VIEW_USERS,
    permissions: authenticatedUser?.permissions,
  })
  const isAdmin = isUserServiceEnabled
    ? hasUserManagementAccess
    : authenticatedUser?.userType === 'LSLAdmin' || authenticatedUser?.userType === 'ClientAdmin'
  const hasRoleManagementAccess = hasUserPermission({
    permissionCode: userPermissionConstants.VIEW_ROLE_MANAGEMENT,
    permissions: authenticatedUser?.permissions,
  })

  const navLinks = [
    { title: Constants.genericNav.navLinks.HOME, path: '/dashboard' },
    { title: Constants.genericNav.navLinks.INVENTORY, path: '/inventory' },
    { title: Constants.genericNav.navLinks.ORDERS, path: '/orders' },
    { title: Constants.genericNav.navLinks.REPORTS, path: '/reports' },
    { title: Constants.genericNav.navLinks.INVOICES, path: '/invoices' },
  ]

  const userLinks = [
    { title: Constants.genericNav.userLinks.ACCOUNT_SETTINGS, path: '/user-settings' },
  ]

  if (isAdmin) {
    userLinks.push({
      title: Constants.genericNav.userLinks.USER_MANAGEMENT,
      path: '/user-management',
    })
  }

  if (hasRoleManagementAccess) {
    userLinks.push({
      title: Constants.genericNav.userLinks.ROLE_MANAGEMENT,
      path: '/role-management',
    })
  }

  const fullName = [authenticatedUser?.firstName, authenticatedUser?.lastName].join(' ')

  const appBarStyle = {
    backgroundColor: theme.palette.primary.main,
    zIndex: 2000,
    height: '80px',
    overflow: 'hidden',
    width: '100%',
    minWidth: '1240px',
  }

  const toolbarStyle = {
    maxHeight: '80px',
    maxWidth: '100%',
  }

  const logoWrapperStyle = {
    display: { xs: 'flex' },
    whiteSpace: 'nowrap',
    alignItems: 'center',
    justifyContent: 'left',
    height: '80px',
    width: '348px',
    minWidth: '348px',
    backgroundImage: `url("${LogoLines}")`,
    backgroundPosition: 'top 0px left 0px',
    backgroundSize: 'cover',
  }
  const companyLogoStyle = { marginLeft: '80px', width: '127.5px', height: '56px' }

  return (
    <AppBar data-testid='generic-nav' sx={appBarStyle} position='sticky'>
      <Toolbar sx={toolbarStyle} disableGutters>
        <Box sx={logoWrapperStyle}>
          <img alt='nav-company-logo' src={CompanyLogo} style={companyLogoStyle} />
        </Box>
        <NavButtons navLinks={navLinks} selected={selected} />
        <UserMenu fullName={fullName} userLinks={userLinks} />
      </Toolbar>
    </AppBar>
  )
}

GenericNav.propTypes = {
  selected: PropTypes.string,
}

export default GenericNav
